export default __webpack_public_path__ + "static/rovo-overlay-remix2-light-be08cf972e78a68f3df0dac1fe6147a3.png";